import { render, staticRenderFns } from "./Afiliasi.vue?vue&type=template&id=0b755135&"
import script from "./Afiliasi.vue?vue&type=script&lang=js&"
export * from "./Afiliasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports